(function(root){
  'use strict';
  // Packages of up to ~9.5 MB: each one travels in its own cart request (staged upload).
  // Shopify accepted 12.5 MB requests in tests (16.10.2026); 40 MB requests fail with 413.
  const LIMIT=9.5*1024*1024,ENTRY_LIMIT=19*1024*1024,TOTAL_LIMIT=240*1024*1024;
  const table=Array.from({length:256},(_,n)=>{for(let i=0;i<8;i++)n=n&1?0xedb88320^(n>>>1):n>>>1;return n>>>0;});
  function crc(bytes){let c=0xffffffff;for(const b of bytes)c=table[(c^b)&255]^(c>>>8);return(c^0xffffffff)>>>0;}
  function header(size){const b=new Uint8Array(size);return{b,v:new DataView(b.buffer)};}
  function safe(name){if(!/^[A-Za-z0-9_.-]{1,80}$/.test(name)||name.includes('..'))throw new Error('Ungültige Motiv-Datei.');return name;}
  async function zip(entries){
    let offset=0;const parts=[],central=[];
    for(const e of entries){
      const name=new TextEncoder().encode(safe(e.name)),bytes=new Uint8Array(await e.file.arrayBuffer()),sum=crc(bytes);
      if(bytes.length>ENTRY_LIMIT)throw new Error('Ein Foto ist zu groß. Bitte verwende eine Datei unter 19 MB.');
      const local=header(30+name.length);local.v.setUint32(0,0x04034b50,true);local.v.setUint16(4,20,true);
      local.v.setUint32(14,sum,true);local.v.setUint32(18,bytes.length,true);local.v.setUint32(22,bytes.length,true);local.v.setUint16(26,name.length,true);local.b.set(name,30);
      const c=header(46+name.length);c.v.setUint32(0,0x02014b50,true);c.v.setUint16(4,20,true);c.v.setUint16(6,20,true);
      c.v.setUint32(16,sum,true);c.v.setUint32(20,bytes.length,true);c.v.setUint32(24,bytes.length,true);c.v.setUint16(28,name.length,true);c.v.setUint32(42,offset,true);c.b.set(name,46);
      parts.push(local.b,e.file);central.push(c.b);offset+=local.b.length+bytes.length;
    }
    const end=header(22),centralSize=central.reduce((n,b)=>n+b.length,0);end.v.setUint32(0,0x06054b50,true);end.v.setUint16(8,entries.length,true);end.v.setUint16(10,entries.length,true);end.v.setUint32(12,centralSize,true);end.v.setUint32(16,offset,true);
    return new File([...parts,...central,end.b],'motive.zip',{type:'application/zip'});
  }
  function typeKey(e){
    const extension=(e.name.match(/\.([A-Za-z0-9]+)$/)?.[1]||'').toLowerCase();
    const restored=({png:'image/png',jpg:'image/jpeg',jpeg:'image/jpeg',webp:'image/webp'})[extension]||extension;
    return String(e.file.type||'').toLowerCase()+'|'+restored;
  }
  async function digest(bytes){
    if(!root.crypto?.subtle)throw new Error('Dein Browser kann die Motiv-Dateien nicht sicher prüfen. Bitte verwende einen aktuellen Browser.');
    return Array.from(new Uint8Array(await root.crypto.subtle.digest('SHA-256',bytes)),b=>b.toString(16).padStart(2,'0')).join('');
  }
  async function sameFile(file,bytes){
    const other=new Uint8Array(await file.arrayBuffer());
    if(other.length!==bytes.length)return false;
    for(let i=0;i<bytes.length;i++)if(other[i]!==bytes[i])return false;
    return true;
  }
  async function build(entries,limit=LIMIT){
    const groups=[],assets={},unique=[],aliases=[],byHash=new Map(),keys=new Set(),names=new Set();
    let group=[],size=22,originalBytes=0,storedBytes=0,duplicateCount=0;
    for(const e of entries){
      safe(e.name);
      if(keys.has(e.key))throw new Error('Eine Motiv-Datei ist nicht eindeutig zugeordnet.');keys.add(e.key);
      if(e.file.size>ENTRY_LIMIT)throw new Error('Ein Foto ist zu groß. Bitte verwende eine Datei unter 19 MB.');
      originalBytes+=e.file.size;
      const bytes=new Uint8Array(await e.file.arrayBuffer()),hash=typeKey(e)+'|'+bytes.length+'|'+await digest(bytes);
      const candidates=byHash.get(hash)||[];let canonical=null;
      for(const candidate of candidates)if(await sameFile(candidate.file,bytes)){canonical=candidate;break;}
      if(canonical){aliases.push([e.key,canonical.key]);duplicateCount++;continue;}
      if(names.has(e.name))throw new Error('Doppelte Motiv-Datei.');names.add(e.name);
      storedBytes+=e.file.size;if(storedBytes>TOTAL_LIMIT)throw new Error('Die Fotos sind zusammen zu groß. Bitte verwende kleinere Bilddateien (zusammen höchstens 240 MB).');
      candidates.push(e);byHash.set(hash,candidates);unique.push(e);
    }
    for(const e of unique){
      const need=e.file.size+100+e.name.length*2;
      if(group.length&&(size+need>limit||group.length>=120)){groups.push(group);group=[];size=22;}
      group.push(e);size+=need;
    }
    if(group.length)groups.push(group);
    if(groups.length>99)throw new Error('Die Fotos sind zusammen zu groß. Bitte verwende kleinere Bilddateien.');
    const files=[];
    for(let i=0;i<groups.length;i++){
      const key='_M'+String(i+1).padStart(2,'0')+'Paket',file=await zip(groups[i]);
      if(file.size>20*1024*1024)throw new Error('Eine Motiv-Datei ist zu groß.');
      files.push([key,file]);for(const e of groups[i])assets[e.key]={packageKey:key,entry:e.name};
    }
    for(const [key,canonicalKey] of aliases)assets[key]={...assets[canonicalKey]};
    return{files,assets,originalBytes,storedBytes,duplicateCount};
  }
  class Reader{
    constructor(bytes){
      if(bytes.byteLength>20*1024*1024)throw new Error('Das Motivpaket ist zu groß.');
      this.bytes=bytes;this.entries=new Map();const v=new DataView(bytes.buffer,bytes.byteOffset,bytes.byteLength);let p=0;
      while(p+4<=bytes.length&&v.getUint32(p,true)===0x04034b50){
        if(p+30>bytes.length)throw new Error('Beschädigtes Motivpaket.');
        const flags=v.getUint16(p+6,true),method=v.getUint16(p+8,true),sum=v.getUint32(p+14,true),size=v.getUint32(p+18,true),raw=v.getUint32(p+22,true),n=v.getUint16(p+26,true),extra=v.getUint16(p+28,true),start=p+30+n+extra;
        if(flags||method||size!==raw||size>ENTRY_LIMIT||start+size>bytes.length||this.entries.size>=120)throw new Error('Ungültiges Motivpaket.');
        const name=safe(new TextDecoder().decode(bytes.subarray(p+30,p+30+n)));
        if(this.entries.has(name))throw new Error('Doppelte Motiv-Datei.');this.entries.set(name,{start,size,sum});p=start+size;
      }
      if(!this.entries.size||p+4>bytes.length||v.getUint32(p,true)!==0x02014b50)throw new Error('Beschädigtes Motivpaket.');
    }
    file(name,type){
      const e=this.entries.get(safe(name));if(!e)throw new Error('Eine Motiv-Datei fehlt.');const b=this.bytes.subarray(e.start,e.start+e.size);
      if(crc(b)!==e.sum)throw new Error('Eine Motiv-Datei wurde beschädigt. Bitte öffne das Set erneut.');
      return new File([b],name,{type});
    }
  }
  root.TheCupLabPackages={build,Reader,crc};
  if(typeof module!=='undefined'&&module.exports)module.exports=root.TheCupLabPackages;
})(typeof window!=='undefined'?window:globalThis);
